/**
 * Reicht die aktive Keyword-Kategorisierung ("Taxonomie") an die Monitoring-Requests durch.
 *
 * Hintergrund: ein Monitoring-Projekt kann mehrere parallele Kategorisierungen haben. Die
 * Standard-Kategorisierung ist im Backend durch ein FEHLENDES taxonomy_id repraesentiert — deshalb
 * wird das Feld nur gesetzt, wenn tatsaechlich eine Zusatz-Taxonomie gewaehlt ist. Ohne Auswahl
 * gehen die Requests bit-identisch raus wie vorher.
 *
 * Der Kontext liegt im Vuex-Store und nicht in Props: er wird von ~14 Komponenten gebraucht, ein
 * Prop-Drill dafuer waere eine zweite Kopie der category_id-Kette.
 *
 * Verwendung in einer Komponente:
 *   import monitoringTaxonomy from "@/mixins/monitoringTaxonomy"
 *   mixins: [monitoringTaxonomy]
 *   ...
 *   let post_data = this.withTaxonomy({ company_id, project_id, category_id })
 *   watch: { taxonomyId() { this.fetchData() } }
 */
export default {
    computed: {
        /** _id der aktiven Taxonomie, oder null fuer die Standard-Kategorisierung. */
        taxonomyId() {
            const taxonomy = this.$store.state.monitoring_taxonomy
            return taxonomy ? taxonomy._id : null
        },
        /** Anzeigename fuer Labels und Tooltips. */
        taxonomyName() {
            const taxonomy = this.$store.state.monitoring_taxonomy
            return taxonomy ? taxonomy.name : "Standard"
        },
        /**
         * Seller- und SERP-Feature-Daten sind fuer Zusatz-Taxonomien forward-only: sie stecken nur in
         * den Roh-SERPs und lassen sich nicht rueckwirkend berechnen. Komponenten, die darauf
         * aufbauen, koennen damit einen Hinweis statt eines leeren Charts zeigen.
         */
        taxonomyHasHistoricSellerData() {
            return !this.taxonomyId
        }
    },
    methods: {
        /** Ergaenzt den Request-Body um taxonomy_id — nur wenn eine Zusatz-Taxonomie aktiv ist. */
        withTaxonomy(post_data) {
            if (this.taxonomyId) post_data.taxonomy_id = this.taxonomyId
            return post_data
        }
    }
}
